import script from "./Navigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./Navigation.vue?vue&type=script&lang=ts&setup=true"

import "./Navigation.vue?vue&type=style&index=0&id=e7c34bb0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7c34bb0"]])

export default __exports__